// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ITfo","label":"styles_label__2hcue"};